import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.34,7.2a.739.739,0,0,1-.65.84c-.03,0-.06.01-.09.01a.746.746,0,0,1-.74-.66,4.938,4.938,0,0,0-1.39-2.84,4.833,4.833,0,0,0-2.84-1.4,4.929,4.929,0,0,0-3.1.62A5.092,5.092,0,0,0,4.04,5.13H5.88a.75.75,0,0,1,0,1.5H2.36a.743.743,0,0,1-.75-.75V2.36a.75.75,0,0,1,1.5,0V3.88a6.375,6.375,0,0,1,1.66-1.4,6.468,6.468,0,0,1,4.06-.82A6.392,6.392,0,0,1,14.34,7.2Zm-.7,2.17H10.12a.75.75,0,0,0,0,1.5h1.84a4.981,4.981,0,0,1-1.49,1.36A4.905,4.905,0,0,1,3.14,8.61a.751.751,0,0,0-1.49.19,6.416,6.416,0,0,0,5.52,5.54,5.728,5.728,0,0,0,.82.05,6.439,6.439,0,0,0,3.23-.87,6.3,6.3,0,0,0,1.67-1.41v1.54a.75.75,0,0,0,1.5,0V10.12A.743.743,0,0,0,13.64,9.37Z';
const draw24px =
  'M20.683,10.911a.744.744,0,0,1-.65.83.311.311,0,0,1-.1.01.752.752,0,0,1-.74-.66,7.225,7.225,0,0,0-6.26-6.28,7.258,7.258,0,0,0-7.14,3.44H9a.75.75,0,0,1,0,1.5H4A.75.75,0,0,1,3.252,9V4a.75.75,0,1,1,1.5,0V7.1a8.746,8.746,0,0,1,15.931,3.81ZM20,14.251H15a.75.75,0,0,0,0,1.5h3.2a7.258,7.258,0,0,1-7.14,3.44A7.275,7.275,0,0,1,4.8,12.9a.741.741,0,0,0-.84-.64.729.729,0,0,0-.64.83,8.741,8.741,0,0,0,7.55,7.58,8.421,8.421,0,0,0,1.119.08,8.735,8.735,0,0,0,4.421-1.2,8.623,8.623,0,0,0,2.839-2.67V20a.75.75,0,0,0,1.5,0V15A.755.755,0,0,0,20,14.251Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowRotateTwoIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowRotateTwo')) as IconWithRender;

ArrowRotateTwoIcon.displayName = 'ArrowRotateTwoIcon';
ArrowRotateTwoIcon.propTypes = Icon.propTypes;
ArrowRotateTwoIcon.renderIcon = (props) => <ArrowRotateTwoIcon {...props} />;
export default ArrowRotateTwoIcon;
